import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.css']
})
export class ReportesComponent {

  powerBiUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
    this.powerBiUrl = this.sanitizeUrl(environment.powerBiUrl);
  }

  ngOnInit(): void { }

  sanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
